/* THIS FILE IS GENERATED. DO NOT EDIT */

import { DynamicStandaloneExtras, PropsFromComponent } from '@/types/component';
import { mergeProps } from '@/utils/merge';
import StandaloneBlogSlider from 'base/components/standalone/BlogSlider';

export const DynamicStandaloneBlogSlider = StandaloneBlogSlider;
export type DynamicStandaloneBlogSliderProps = PropsFromComponent<typeof StandaloneBlogSlider>;

export const DynamicStandaloneBlogSliderWith = (extras: DynamicStandaloneExtras): typeof StandaloneBlogSlider => {
    return function DynamicStandaloneBlogSlider(props) {
        const theme = extras.theme.useTheme(extras.theme.key || 'BlogSlider');
        return <StandaloneBlogSlider {...mergeProps({ options: { theme } }, props)} />;
    }
}